import type { VV } from '@semios/app-platform-value-type-definitions'
import moment from 'moment-timezone'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import type { TSplineSeriesData } from '../../types'

type TFilterPressureData =
  | NonNullable<NonNullable<VV.Response['points']>[string]['values']['irrigationPressureSemios_preFilter']>
  | NonNullable<NonNullable<VV.Response['points']>[string]['values']['irrigationPressureSemios_postFilter']>

export const processFilterPressureData = ({
  filterPressureData,
  timezone,
}: {
  filterPressureData: TFilterPressureData | undefined
  timezone: string
}): TSplineSeriesData[] => {
  return (filterPressureData ?? []).flatMap((p) =>
    (p?.timeseries ?? []).map((d) => {
      const value = unitConverter.irrigationPressure(d.value === null ? null : d.value.average).value()

      return {
        x: moment.tz(d.timestamp, timezone).valueOf(),
        y: value === null ? undefined : value,
      }
    }),
  )
}
